/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="notificationTemplates.module.ts" />

module Meevo.Plugins.NotificationTemplates {
    class NotificationTemplatesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "$http",
            "$translate",
            "$timeout",
            "$interval"
        ];

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: any,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $http: angular.IHttpService,
            protected translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $interval: angular.IIntervalService,
            public notificationiframe: HTMLIFrameElement,
            public smsiframe: HTMLIFrameElement,
            public tags: Array<any>
            ) {

            
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            $http.get(`/api/Template/Type/List`)
                .then((response) => {
                    return this.securityService.checkSecurityKey(this.meevoSecurityKeys.NOTIFICATIONS_SMS_ACTION_ALLOWTWOWAY)
                        .then(result => {
                            if (result != Meevo.Model.SecurityAccessEnum.Grant) {
                                $scope.dataSourceCommType = _.filter(response.data, (item: any) => { return item.communicationType != 2103; });
                            }
                            else {
                                this.$scope.dataSourceCommType = response.data;
                            }

                            this.$scope.communicationTypes = _.chain($scope.dataSourceCommType).pluck("communicationType").unique().value();
                        });
                });


            $http({
                url: "/api/businesstype/List/",
                method: "POST",
                headers: { "Content-Type": "application/json;charset=UTF-8" },
                data: { "pageNumber": 0, "itemsPerPage": 20, "criteria": { IncludeAllLocationsListItem: false, "filter": "%" }, "asLocationId": null }
            }).then(response => {

                $scope.templateBusinessType = [];
                $scope.templateBusinessType = $scope.templateBusinessType.concat(response.data);


            });

            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.CommunicationTypeUserEnum)
                .then((response: any) => {
                    $scope.communicationUserType = response;
                });

            $scope.dataSourceFilter = (value) => {
                if ($scope.criteria.communicationTypeUser) {
                    return value.communicationTypeUser == $scope.criteria.communicationTypeUser;
                }
                return value;
            };

            if (this.identityService.inCentralOfficeMode()) {
                $scope.allBusinessTypeId = this.identityService.current().tenantData.allBusinessTypeId;
            }

            $scope.inputLastFocused = {};

            this.createContext();

        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            this.context = new NotificationTemplatesContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.$http, this.translate, this.$scope, this.$timeout, this.$interval);

            this.context.activate(this.selectedItemId);
            this.context.deactivate = () => {
                this.visualState = Model.MaintenanceFormVisualState.Search;
            }     
        }

    }



    angular.module("meevo.plugins.notificationTemplates")
        .controller("meevo.plugins.notificationTemplates.NotificationTemplatesController", NotificationTemplatesController)
        
}